var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "modal",
      attrs: {
        id: "display-builder-publish-modal",
        title: _vm.title,
        size: "lg",
        "no-close-on-backdrop": "",
      },
      on: { hide: _vm.close, shown: _vm.handleModalShown },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "w-100 d-flex justify-content-end" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "mr-2",
                      attrs: { variant: "outline-secondary" },
                      on: { click: _vm.close },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.bynderPublishResults &&
                              _vm.bynderPublishResults.length > 0
                              ? "Close"
                              : "Cancel"
                          ) +
                          "\n      "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.isBynder
                    ? _c(
                        "b-button",
                        {
                          attrs: {
                            variant: "primary",
                            disabled: _vm.isPublishing || !_vm.platformId,
                          },
                          on: { click: _vm.handleBynderPublish },
                        },
                        [
                          _vm.isPublishing
                            ? _c("b-spinner", {
                                staticClass: "mr-1",
                                attrs: { small: "" },
                              })
                            : _vm._e(),
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm.isPublishing
                                  ? "Publishing..."
                                  : _vm.actionButtonText("Bynder")
                              ) +
                              "\n      "
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isSharepoint
                    ? _c(
                        "b-button",
                        {
                          attrs: {
                            variant: "primary",
                            disabled: _vm.isPublishing || !_vm.platformId,
                          },
                          on: { click: _vm.handleSharePointPublish },
                        },
                        [
                          _vm.isPublishing
                            ? _c("b-spinner", {
                                staticClass: "mr-1",
                                attrs: { small: "" },
                              })
                            : _vm._e(),
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm.isPublishing
                                  ? "Publishing..."
                                  : _vm.actionButtonText("SharePoint")
                              ) +
                              "\n      "
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "b-card",
        { staticClass: "mb-3" },
        [
          _c(
            "b-form",
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Platform",
                            "label-for": "platform-select",
                            "label-class": "mb-1",
                          },
                        },
                        [
                          _c(
                            "b-form-select",
                            {
                              attrs: { id: "platform-select", size: "sm" },
                              on: { change: _vm.handlePlatformChange },
                              model: {
                                value: _vm.platformId,
                                callback: function ($$v) {
                                  _vm.platformId = $$v
                                },
                                expression: "platformId",
                              },
                            },
                            [
                              _c(
                                "b-form-select-option",
                                {
                                  attrs: {
                                    value: "",
                                    disabled: "",
                                    selected: "",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                Select Platform\n              "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm._l(_vm.platforms, function (platform) {
                                return _c(
                                  "b-form-select-option",
                                  {
                                    key: platform.id,
                                    attrs: { value: platform.id },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(platform.name) +
                                        "\n              "
                                    ),
                                  ]
                                )
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "border rounded p-3 mb-2" }, [
            _c("div", { staticClass: "form-group row mt-2" }, [
              _c("div", { staticClass: "col-md-4" }, [
                _c(
                  "div",
                  { staticClass: "d-flex align-items-center" },
                  [
                    _c("label", { staticClass: "mb-0 mr-2" }, [_vm._v("DPI")]),
                    _vm._v(" "),
                    _c(
                      "b-form-select",
                      {
                        attrs: {
                          size: "sm",
                          disabled: _vm.extension === "webp",
                        },
                        model: {
                          value: _vm.selectedDPI,
                          callback: function ($$v) {
                            _vm.selectedDPI = $$v
                          },
                          expression: "selectedDPI",
                        },
                      },
                      _vm._l(_vm.dpiOptions, function (dpi) {
                        return _c(
                          "b-form-select-option",
                          { key: dpi, attrs: { value: dpi } },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(dpi) +
                                "\n              "
                            ),
                          ]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-4" }, [
                _c(
                  "div",
                  { staticClass: "d-flex align-items-center" },
                  [
                    _c("label", { staticClass: "mb-0 mr-2" }, [
                      _vm._v("Format"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-form-select",
                      {
                        attrs: { size: "sm" },
                        model: {
                          value: _vm.extension,
                          callback: function ($$v) {
                            _vm.extension = $$v
                          },
                          expression: "extension",
                        },
                      },
                      _vm._l(_vm.formatOptions, function (format) {
                        return _c(
                          "b-form-select-option",
                          { key: format.value, attrs: { value: format.value } },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(format.label) +
                                "\n              "
                            ),
                          ]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _vm.publishToBynder && _vm.isBynderMetaAvailable
                ? _c(
                    "div",
                    { staticClass: "col-md-4 d-flex justify-content-end" },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "outline-primary", size: "sm" },
                          on: { click: _vm.configureMetadata },
                        },
                        [_vm._v("\n            Configure Metadata\n          ")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-group row px-3 mt-3" },
              [
                _c("label", { staticClass: "mb-0" }, [_vm._v("Filename")]),
                _vm._v(" "),
                _c("b-form-input", {
                  attrs: { placeholder: "Optional Filename" },
                  model: {
                    value: _vm.optionalFilename,
                    callback: function ($$v) {
                      _vm.optionalFilename = $$v
                    },
                    expression: "optionalFilename",
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("AdditionalMetaproperties", {
            attrs: { "is-regular-publish": false, "is-ai-publish": false },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.bynderPublishResults && _vm.bynderPublishResults.length > 0
        ? _c("b-card", { staticClass: "mb-3 border-success" }, [
            _c("div", { staticClass: "d-flex align-items-center mb-3" }, [
              _c("h6", { staticClass: "mb-0 text-success" }, [
                _vm._v("\n        Successfully Published to Platform\n      "),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "published-files" },
              _vm._l(_vm.bynderPublishResults, function (result) {
                return _c(
                  "div",
                  {
                    key: result.file_id,
                    staticClass:
                      "published-file-item mb-2 p-2 bg-light rounded",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex justify-content-between align-items-center",
                      },
                      [
                        _c("div", [
                          _c("strong", [_vm._v(_vm._s(result.file_name))]),
                          _vm._v(" "),
                          result.media_id
                            ? _c("div", { staticClass: "text-muted small" }, [
                                _vm._v(
                                  "\n              Asset ID: " +
                                    _vm._s(result.media_id) +
                                    "\n            "
                                ),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c("span", { staticClass: "badge badge-success" }, [
                            _vm._v("\n              Published\n            "),
                          ]),
                        ]),
                      ]
                    ),
                  ]
                )
              }),
              0
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.publishErrors && _vm.publishErrors.length > 0
        ? _c("b-card", { staticClass: "mb-3 border-danger" }, [
            _c("div", { staticClass: "d-flex align-items-center mb-3" }, [
              _c("h6", { staticClass: "mb-0 text-danger" }, [
                _vm._v("\n        Publishing Errors\n      "),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "error-files" },
              _vm._l(_vm.publishErrors, function (error) {
                return _c(
                  "div",
                  {
                    key: error.file_id,
                    staticClass: "error-file-item mb-2 p-2 bg-light rounded",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex justify-content-between align-items-start",
                      },
                      [
                        _c("div", { staticClass: "flex-grow-1" }, [
                          _c("strong", [_vm._v(_vm._s(error.file_name))]),
                          _vm._v(" "),
                          error.media_id
                            ? _c("div", { staticClass: "text-muted small" }, [
                                _vm._v(
                                  "\n              Asset ID: " +
                                    _vm._s(error.media_id) +
                                    "\n            "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "text-danger small mt-1" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(error.error_message) +
                                "\n            "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c("span", { staticClass: "badge badge-danger" }, [
                            _vm._v("\n              Failed\n            "),
                          ]),
                        ]),
                      ]
                    ),
                  ]
                )
              }),
              0
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }